export default {
  notFound: {
    seo: { title: 'الصفحة غير موجودة' },
    badge: 'خطأ 404',
    title: 'لقد خرجت عن المسار',
    description:
      'عنوان URL المطلوب غير موجود على خريطتنا. تحقق من العنوان أو عد إلى الصفحة الرئيسية أو تواصل معنا إذا كنت بحاجة إلى مساعدة.',
    requestedPathLabel: 'المسار المطلوب',
    backHome: 'العودة إلى الرئيسية',
    contactUs: 'تواصل معنا',
    pricing: 'الأسعار',
    tagline: 'Geofleet · المرحلة الأخيرة وعمليات الأسطول',
  },
};
